import { render, staticRenderFns } from "./TimeSlotsReservations.vue?vue&type=template&id=4574b73d&scoped=true"
import script from "./TimeSlotsReservations.vue?vue&type=script&lang=js"
export * from "./TimeSlotsReservations.vue?vue&type=script&lang=js"
import style0 from "./TimeSlotsReservations.vue?vue&type=style&index=0&id=4574b73d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4574b73d",
  null
  
)

export default component.exports